import { Typography } from "@material-tailwind/react";
import React, { ChangeEvent } from "react";
import { IoIosAddCircle } from "react-icons/io";

interface ImageUploadProps {
  label: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  preview: string | null | undefined;
  height?: string; // Make the height prop optional
}

const ImageUpload: React.FC<ImageUploadProps> = ({
  label,
  onChange,
  preview,
  height = "10rem", // Set a default value for height
}) => (
  <label
    htmlFor={`imageInput-${label}`}
    className="w-11/12 md:w-1/1 lg:w-1/3 xl:w-1/5 p-2"
  >
    <div
      className="bg-gray-200 flex items-center justify-center cursor-pointer border border-gray-400 rounded-lg text-center"
      style={{ height: height }}
    >
      {preview ? (
        <img
          src={preview}
          alt={`${label} preview`}
          className="w-full object-cover rounded-lg h-full"
        />
      ) : (
        <div className="flex flex-col items-center text-gray-400 text-sm justify-center min-h-full">
          <IoIosAddCircle className="text-gray-900 h-16 w-16 mx-auto" />
          <Typography  placeholder={undefined}  className="text-black">{label}</Typography>
        </div>
      )}
      <input
        id={`imageInput-${label}`}
        type="file"
        accept="image/*"
        className="hidden"
        onChange={onChange}
      />
    </div>
  </label>
);

export default ImageUpload;
